import { useEffect, useState } from "react";
import { logAnalyticsAndHotjarEvent } from "../../main";
import { useAppSelector } from "../../app/hooks";
import { Button, ToastMessage } from "@almafintech/react-components";
import InfoIcon from "../../assets/images/icons/alert/info.svg";
import ErrorIcon from "../../assets/images/icons/alert/error-cross.svg";

import styles from "./InteractiveInformation.module.scss";

interface Button {
  text: string;
  onClick: () => void | Promise<void>;
}

interface InformationProps {
  alertType: "INFO" | "ERROR"
  title: string;
  subtitle: string | React.ReactNode;
  description?: string;
  primaryButton: Button;
  secondaryButton?: Button;
}

const InteractiveInformation = ({
  alertType,
  title,
  subtitle,
  description,
  primaryButton,
  secondaryButton,
}: InformationProps) => {
  const {
    informationContainer,
    modalAlert,
    primaryButton: primaryButtonStyle,
    secondaryButton: secondaryButtonStyle,
  } = styles;

  const [isLoading, setIsLoading] = useState({
    primaryButton: false,
    secondaryButton: false,
  });
  const { type } = useAppSelector((state) => state.infoStep);

  useEffect(() => {
    if (type === "PENDING_REGISTRY_LOCAL" || type === "PENDING_REGISTRY_REMOTE")
      logAnalyticsAndHotjarEvent("modal_returning_user_displayed");
  }, []);

  const onSecondaryButtonClick = async () => {
    setIsLoading({ ...isLoading, secondaryButton: true });
    secondaryButton && (await secondaryButton.onClick());
    setIsLoading({ ...isLoading, secondaryButton: false });
  };

  const onPrimaryButtonClick = async () => {
    setIsLoading({ ...isLoading, primaryButton: true });
    await primaryButton.onClick();
    setIsLoading({ ...isLoading, primaryButton: false });
  };

  return (
    <div className={informationContainer}>
      <ToastMessage
        messageId="informationAlert"
        position="top-center"
        className={modalAlert}
      />
      <img src={alertType === "INFO" ? InfoIcon : ErrorIcon} />
      <h1>{title}</h1>
      <p>{subtitle}</p>
      {description && <p>{description}</p>}
      <div>
        {secondaryButton?.text && (
          <Button
            className={secondaryButtonStyle}
            onClick={onSecondaryButtonClick}
            text={secondaryButton?.text}
            variant="secondary"
            isLoading={isLoading.primaryButton || isLoading.secondaryButton}
            disabled={isLoading.secondaryButton}
          />
        )}
        <Button
          className={primaryButtonStyle}
          onClick={onPrimaryButtonClick}
          text={primaryButton.text}
          disabled={isLoading.primaryButton || isLoading.secondaryButton}
          isLoading={isLoading.primaryButton}
        />
      </div>
    </div>
  );
};

export default InteractiveInformation;
